import React from "react";
import { Glyphicon } from "react-bootstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";

import styles from "./Matches.scss";

class Matches extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRejectedProjects: false
    };

    this.toogleRejectedProjects = this.toogleRejectedProjects.bind(this);
  }

  render() {
    const matches = this.getCurrentMatches();
    const mappedMatches = matches.map(match => {
      const { project } = match;
      return {
        rowKey: match.id,
        disabled: match.declined,
        paused: project.status_id === 10,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: project.city,
            orderByText: project.city
          },
          {
            displayText: formatDateSmall(match.updated_at),
            orderByText: match.updated_at
          },
          {
            displayText: this.getActions()
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "PROJECT"
        },
        {
          displayText: "LOCATION"
        },
        {
          displayText: "MATCHED ON"
        },
        {
          displayText: "",
          sortDisable: true
        }
      ],
      rows: mappedMatches
    };

    const defaultSort = {
      headerIndex: 1,
      order: "desc"
    };

    return (
      <div className={styles.matches}>
        <h2 className={styles.pageTitle}>
          Active Matches
          <span className={styles.filters}>{this.getFilterButtons()}</span>
        </h2>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name="AdminMatchesTable"
          colsConfig={["50%", "25%", "20%", "5%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  getCurrentMatches() {
    let matches;
    if (this.state.showRejectedProjects) {
      matches = _.filter(this.props.matches, { pitched: false });
    } else {
      matches = _.filter(this.props.matches, {
        declined: false,
        pitched: false
      });
    }

    return matches;
  }

  getFilterButtons() {
    const toogleRejectedComponent = this.state.showRejectedProjects ? (
      <span>
        {" "}
        <Glyphicon glyph="eye-close" />
        &nbsp; Hide Rejected
      </span>
    ) : (
      <span>
        {" "}
        <Glyphicon glyph="eye-open" />
        &nbsp; Show Rejected
      </span>
    );

    return (
      <div className={styles.filterButtons}>
        <span
          className={styles.filterButtonsItem}
          onClick={this.toogleRejectedProjects}
        >
          {toogleRejectedComponent}
        </span>
      </div>
    );
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "employer.profile.company") || {};

    return (
      <div className={styles.rowHeader}>
        <div>
          <Link to={`/admin/company/${company.id}`}>{company.name}</Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link to={`/admin/project/${project.id}/detail`}>
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getActions() {
    return (
      <div className={styles.actionsContainer}>
        <Link to={`#`}>
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );
  }

  toogleRejectedProjects() {
    this.setState(prevState => {
      return {
        showRejectedProjects: !prevState.showRejectedProjects
      };
    });
  }
}

export default Matches;



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/matches/components/Matches.js